import React, { useEffect, useState } from "react";
import Card from "../../../components/Card";
import { Link } from "react-router-dom";
import ProfileHeader from "../../../components/profile-header";
import {
  Row,
  Col,
  Tab, 
  Nav,
  Container,
  Dropdown,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import img1 from "../../../assets/images/page-img/profile-bg1.jpg";
import { getToken } from "../../../utils/auth";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { MdOutlineDone } from "react-icons/md";
import useAuth from "../../../utils/useAuth";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../Context/UserContext";
import { CircularProgress } from "@mui/material";

const Groups = () => {
  useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const { t, i18n } = useTranslation();
  const [description, setDescription] = useState("");
  const [descriptionEdit, setDescriptionEdit] = useState("");
  const [showModal, setShowModal] = useState(true);
  const [groupName, setGroupName] = useState();
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState('');
  const [loadingFull, setLoadingFull] = React.useState(false);

  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
};

const closeQrPopup = () => {
    setQrPopupOpen(false);
};
  const openForm = () => {
    setShowModal(true);
  };

  const closeForm = () => {
    setShowModal(false);
  };

  const handleGroupDetail = () => {
    // navigate(`/group-detail`);
    navigate(`/group-detail/${groupName}`);
  };
  const handleNavigate = (id) => {
    navigate(`/group-detail/${id}`);
  };
  const [formData, setFormData] = useState({
    groupname: "",
    image: "",
    backgroundImg:"",
    category: "public",
    note: "",
  });
  const [formDataEdit, setFormDataEdit] = useState({
    id:"",
    groupname: "",
    image: "",
    backgroundImg:"",
    category: "public",
    note: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    setFormDataEdit({
      ...formDataEdit,
      [name]: value,
    });
  };
  const [imagePreview, setImagePreview] = useState(null);

  const handleChangeImage = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 1 * 1024 * 1024) {
        toast.error("File size must not exceed 1MB");
        return;
    }
    setFormData({
        ...formData,
        image: file,
    });
    if (file) {
      const preview = URL.createObjectURL(file); 
      setImagePreview([preview]);
    }
};
const handleChangeImageEdit = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 1 * 1024 * 1024) {
        toast.error("File size must not exceed 1MB");
        return;
    }
    setFormDataEdit({
        ...formDataEdit,
        image: file,
    });
    if (file) {
      const preview = URL.createObjectURL(file); 
      setImagePreview([preview]);
    }
};
  const [imagePreviewBG, setImagePreviewBG] = useState(null);

  const handleChangeImageBG = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 1 * 1024 * 1024) {
        toast.error("File size must not exceed 1MB");
        return;
    }
    setFormData({
        ...formData,
        backgroundImg: file,
    });
    if (file) {
      const preview = URL.createObjectURL(file); 
      setImagePreviewBG([preview]);
    }
};
const handleChangeImageEditBG = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 1 * 1024 * 1024) {
        toast.error("File size must not exceed 1MB");
        return;
    }
    setFormDataEdit({
        ...formDataEdit,
        backgroundImg: file,
    });
    if (file) {
      const preview = URL.createObjectURL(file); 
      setImagePreviewBG([preview]);
    }
};
// console.log("formData",formData)
// console.log("formData edit",formDataEdit)
  const [categorypost, setCategorypost] = useState("public");
  const [categorypostEdit, setCategorypostEdit] = useState("public");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };
  const handleCategoryChangeEdit = (e) => {
    setCategorypostEdit(e.target.value);
  };

  const handleGroup = async () => {
    if (
      !formData.groupname ||
      !description ||
      !formData.image ||
      !formData.backgroundImg ||
      !categorypost
    ) {
      toast.error("Please fill required fields");
      return;
    }

    try {
      const formDataObject = new FormData();
      formDataObject.append("groupName", formData.groupname);
      formDataObject.append("description", description);
      formDataObject.append("profileImg", formData.image);
      formDataObject.append("backgroundImg", formData.backgroundImg);
      formDataObject.append("note", formData.note);
      formDataObject.append("category", categorypost);

      const token = getToken();

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/group`,
        formDataObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      handleAllGroups();
      toast.success("Group created successfully");
      setFormData({
        groupname: "",
        image: "",
        category: "public",
        note: "",
        backgroundImg:""
      });
      setImagePreviewBG(null)
      setImagePreview(null)
      setDescription("");
      //   handleAllPost(true);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed creating Group");
      console.log("Failed creating Group", error);
    } finally {
      setShow(false);
    }
  };
  const handleGroupEdit = async () => {
    if (
      !formDataEdit.groupname ||
      !descriptionEdit ||
      !formDataEdit.image ||
      !formDataEdit.backgroundImg ||
      !categorypostEdit
    ) {
      toast.error("Please fill required fields");
      return;
    }

    try {
      const formDataObject = new FormData();
      formDataObject.append("groupName", formDataEdit.groupname);
      formDataObject.append("description", descriptionEdit);
      formDataObject.append("profileImg", formDataEdit.image);
      formDataObject.append("backgroundImg", formDataEdit.backgroundImg);
      formDataObject.append("note", formDataEdit.note);
      formDataObject.append("category", categorypostEdit);

      const token = getToken();

      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/group/${formDataEdit.id}`,
        formDataObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      handleAllGroups();
      toast.success("Group updated successfully");
      setFormDataEdit({
        id:"",
        groupname: "",
        image: "",
        category: "public",
        note: "",
        backgroundImg:""
      });
      setDescriptionEdit("");
      setImagePreviewBG(null)
      setImagePreview(null)
      //   handleAllPost(true);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed updating Group");
      console.log("Failed updating Group", error);
    } finally {
      setShowEdit(false);
    }
  };
  const [groups, setGroups] = useState([]);
  const [groupType, setGroupType] = useState("my");
  const handleAllGroups = async () => {
    try {
      setLoadingFull(true)
      const token = getToken();
      let url = `${process.env.REACT_APP_URL}/api/group/all`;
      if (groupType) {
        url += `?searchfor=${groupType}`;
      }
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setGroups(response.data.data);
    } catch (error) {
      console.log("Failed Fetching Group", error);
    } finally{
      setLoadingFull(false)
    }
  };
  useEffect(() => {
    handleAllGroups();
  }, []);
  useEffect(() => {
    handleAllGroups();
  }, [groupType]);

  const [currentDate, setCurrentDate] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setImagePreview(null)
    setImagePreviewBG(null);
    setFormData({
      groupname: "",
      image: "",
      category: "public",
      note: "",
      backgroundImg:""
    });
    setFormDataEdit({
      id:"",
      groupname: "",
      image: "",
      category: "public",
      note: "",
      backgroundImg:""
    })
  }
  const handleShow = () => setShow(true);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => {
    setShowEdit(false);
    setImagePreview(null)
    setImagePreviewBG(null);
    setFormData({
      groupname: "",
      image: "",
      category: "public",
      note: "",
      backgroundImg:""
    });
    setFormDataEdit({
      id:"",
      groupname: "",
      image: "",
      category: "public",
      note: "",
      backgroundImg:""
    })
  }
    const handleShowEdit = (record) => {
    setShowEdit(true);
    setFormDataEdit({
      id: record?._id || '',
      groupname: record?.groupName || '',
      note: record?.note || '',
      image: record?.uploadedFileLink || '',
      backgroundImg: record?.backgroundImageLink || ''
    })
    setDescriptionEdit(record?.description);
    setCategorypostEdit(record?.category)
  }

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  useEffect(() => {
    const intervalId = setInterval(() => {
      const date = new Date();
      const dayOfMonth = date.getDate();
      setCurrentDate(dayOfMonth);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);
  const handleJoinGroup = async (groupID, isPrivate) => { 
    setGroupName(groupID);
    try {
      setLoadingFull(true)

      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/group/join/${groupID}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response.data.message);
      handleAllGroups()
      if (!isPrivate) {
        handleShow1();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed Joining Group");
      console.log("Failed Joining Group", error);
    } finally{
      setLoadingFull(false)
    }
};

  const { userData } = useUser();
  const profileImage = userData?.profileImageLink ? userData?.profileImageLink : "/profile.png";
 
    const [user, setUser] = useState("");
    const fetchUserData = async () => {
      try {
        const token = getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/user`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log("user details header", response.data.data);
        setUser(response?.data?.data);
      } catch (error) {
        console.error("Failed Fetching Details", error);
      }
    };
    useEffect(() => {
        fetchUserData();
    },[])

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
  {loadingFull && (
    <div style={styles.loaderOverlay}>
      <CircularProgress style={{ color: "white" }} />
    </div>
  )}
{/* <ProfileHeader  img={img7} title="Groups" /> */}
      <div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col lg="12">
              <Tab.Container defaultActiveKey="f1">
                <Card className="cardnavbar">
                  <div className="user-tabing">
                   

                                           <Nav
                                                                  variant="pills"
                                                                  className="connection-tabs-nav p-0 m-0 round"
                                                                >
                                                                  <Nav.Item as="li">
                                                                    <Nav.Link 
                                                                     onClick={(e) => {setGroupType("my")
                          setImagePreview(null);
                          setImagePreviewBG(null);
                          setFormData({
                            groupname: "",
                            image: "",
                            category: "public",
                            note: "",
                            backgroundImg:""
                          });
                          setFormDataEdit({
                            id:"",
                            groupname: "",
                            image: "",
                            category: "public",
                            note: "",
                            backgroundImg:""
                          });}}
                          className="text-center"
                          eventKey="f1"
                          href="#"
                                                                    >
                                                                        {t('my_groups')}
                                                                    </Nav.Link>
                                                                  </Nav.Item>
                                                                
                                                                  <Nav.Item as="li">
                                                                    <Nav.Link
                                                                     onClick={(e) => {setGroupType("all")
  setImagePreview(null);
  setImagePreviewBG(null);
  setFormData({
    groupname: "",
    image: "",
    category: "public",
    note: "",
    backgroundImg:""
  });
  setFormDataEdit({
    id:"",
    groupname: "",
    image: "",
    category: "public",
    note: "",
    backgroundImg:""
  });}}                          className="text-center"
                          eventKey="f2"
                          href="#"
                                                                    >
                                                                     {t('other_groups')}
                                                                    </Nav.Link>
                                                                  </Nav.Item>
                                                                </Nav>
                  </div>
                </Card>
                <Tab.Content className="forum-content">
                  <Tab.Pane eventKey="f1">
                    <Card
                      id="post-modal-data"
                      className="card-block card-stretch card-height"
                    >
                      <div className="card-header d-flex justify-content-between">
                        <div className="header-title">
                          <h4 className="card-title">{t('create_group')}</h4>
                        </div>
                      </div>
                      <Card.Body>
                        <div className="d-flex align-items-center">
                          <div className="user-img">
                            <img
                            src={profileImage}
                              // src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`}
                              alt="user1"
                              className="avatar-60 rounded-circle"
                            />
                          </div>
                         
                          <form
                            className="post-text ms-3 w-100 "
                            onClick={handleShow}
                          >
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder={t('click_to_create_group')}
                              style={{ border: "none" }}
                            />
                          </form>
                        </div>
                      </Card.Body>
                      {/* <Modal
                        size="lg"
                        className="fade"
                        id="post-modal"
                        onHide={handleClose}
                        show={show}
                        style={{ marginTop: "100px", overflow: "hidden" }}
                      >
                        <Modal.Header className="d-flex justify-content-between">
                          <Modal.Title id="post-modalLabel">
                            {t('create_group')}
                          </Modal.Title>
                          <Link to="#" className="lh-1" onClick={handleClose}>
                            <span className="material-symbols-outlined">
                              close
                            </span>
                          </Link>
                        </Modal.Header>
                        <Modal.Body
                          style={{ maxHeight: "450px", overflowY: "auto" }}
                        >
                          <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t('group_name')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="groupname"
                                  value={formData.groupname}
                                  onChange={handleChange}
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('enter_group_name')}
                                  required
                                />
                              </Form.Group>
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                {t('description')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                             
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  name="description"
                                  value={description}
                                  onChange={(e) =>
                                    setDescription(e.target.value)
                                  }
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('description')}
                                  required
                                />
                              </Form.Group>
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t('select_a_category')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <div className="mb-0 ">
                                  <Form.Check
                                    style={{ marginRight: "20px" }}
                                    type="radio"
                                    name="category"
                                    value="public"
                                    label={t('public')}
                                    checked={categorypost === "public"}
                                    onChange={handleCategoryChange}
                                    required
                                  />
                                  <Form.Check
                                    type="radio"
                                    name="category"
                                    value="private"
                                    label={t('private')}
                                    checked={categorypost === "private"}
                                    onChange={handleCategoryChange}
                                    required
                                  />
                                </div>
                              </Form.Group>
                            </li>

                            <li className="col-12 mb-3">
                              <Form.Label>
                              {t('image')} <span style={{ color: "red" }}>*</span>
                              </Form.Label>

                              <label
                                htmlFor="file-input"
                                style={{ cursor: "pointer", width: "100%" }}
                              >
                                <div
                                  className="bg-soft-primary rounded p-1 pointer"
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: "1.2rem",
                                    position: "relative",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <input
                                    id="file-input"
                                    type="file"
                                    name="file"
                                    style={{ display: "none" }}
                                    onChange={handleChangeImage}
                                  />
                                  <span>
                                    {formData.image ? (
                                      <MdOutlineDone
                                        style={{ fontSize: "25px" }}
                                      />
                                    ) : (
                                      <i className="fas fa-upload"></i>
                                    )}
                                  </span>
                                  <p style={{ marginTop: ".5rem" }}>
                                    {t('click_to_select_files')}
                                  </p>
                                </div>
                              </label>

                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>{t('note')} </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="note"
                                  value={formData.note}
                                  onChange={handleChange}
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('note')}
                                  required
                                />
                              </Form.Group>
                            </li>
                          </ul>

                          <button
                            type="submit"
                            className="btn btn-primary d-block w-100 mt-3"
                            onClick={handleGroup}
                          >
                            {t('Create')}
                          </button>
                        </Modal.Body>
                      </Modal> */}
                      {/* <Modal
                        size="lg"
                        className="fade"
                        id="post-modal"
                        onHide={handleCloseEdit}
                        show={showEdit}
                        style={{ marginTop: "100px", overflow: "hidden" }}
                      >
                        <Modal.Header className="d-flex justify-content-between">
                          <Modal.Title id="post-modalLabel">
                            {t('edit_group')}
                          </Modal.Title>
                          <Link to="#" className="lh-1" onClick={handleCloseEdit}>
                            <span className="material-symbols-outlined">
                              close
                            </span>
                          </Link>
                        </Modal.Header>
                        <Modal.Body
                          style={{ maxHeight: "450px", overflowY: "auto" }}
                        >
                          <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t('group_name')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="groupname"
                                  value={formDataEdit.groupname}
                                  onChange={handleChangeEdit}
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('enter_group_name')}
                                  required
                                />
                              </Form.Group>
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                {t('description')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                            
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  name="description"
                                  value={descriptionEdit}
                                  onChange={(e) =>
                                    setDescriptionEdit(e.target.value)
                                  }
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('description')}
                                  required
                                />
                              </Form.Group>
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t('select_a_category')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <div className="mb-0 ">
                                  <Form.Check
                                    style={{ marginRight: "20px" }}
                                    type="radio"
                                    name="category"
                                    value="public"
                                    label={t('public')}
                                    checked={categorypostEdit === "public"}
                                    onChange={handleCategoryChangeEdit}
                                    required
                                  />
                                  <Form.Check
                                    type="radio"
                                    name="category"
                                    value="private"
                                    label={t('private')}
                                    checked={categorypostEdit === "private"}
                                    onChange={handleCategoryChangeEdit}
                                    required
                                  />
                                </div>
                              </Form.Group>
                            </li>

                            <li className="col-12 mb-3">
                              <Form.Label>
                              {t('image')} <span style={{ color: "red" }}>*</span>
                              </Form.Label>

                              <label
                                htmlFor="file-input"
                                style={{ cursor: "pointer", width: "100%" }}
                              >
                                <div
                                  className="bg-soft-primary rounded p-1 pointer"
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: "1.2rem",
                                    position: "relative",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <input
                                    id="file-input"
                                    type="file"
                                    name="file"
                                    style={{ display: "none" }}
                                    onChange={handleChangeImageEdit}
                                  />
                                  <span>
                                    {formData.image ? (
                                      <MdOutlineDone
                                        style={{ fontSize: "25px" }}
                                      />
                                    ) : (
                                      <i className="fas fa-upload"></i>
                                    )}
                                  </span>
                                  <p style={{ marginTop: ".5rem" }}>
                                    {t('click_to_select_files')}
                                  </p>
                                </div>
                              </label>
                              </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>{t('note')} </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="note"
                                  value={formDataEdit.note}
                                  onChange={handleChangeEdit}
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('note')}
                                  required
                                />
                              </Form.Group>
                            </li>
                          </ul>

                          <button
                            type="submit"
                            className="btn btn-primary d-block w-100 mt-3"
                            onClick={handleGroupEdit}
                          >
                            {t('update')}
                          </button>
                        </Modal.Body>
                      </Modal> */}


                      <Modal size="sm" className="fade" id="qr-modal" onHide={closeQrPopup} show={qrPopupOpen} centered >
                <Modal.Header closeButton>
                    <Modal.Title>{t('qr_code')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img src={qrImageUrl} alt="QR Code" style={{ maxWidth: '100%', height: 'auto' }} />
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={closeQrPopup}>{t('close')}</button>
                </Modal.Footer>

            </Modal>
                    </Card>
                    <div className="d-grid gap-3 d-grid-template-1fr-19">
                      {groups && groups.length > 0 ? (
                        groups.map((data) => (
                          <Card className="mb-0">
                            <div className="position-relative">

                              <img
                                loading="lazy"
                                src={data?.backgroundImageLink || img1}
                                alt="profile-bg"
                                style={{height:"120px", width:"100%"}}
                                className="rounded img-fluid"
                              />


<ul 
  className="header-nav list-inline d-flex align-items-center p-0 m-0" 
  style={{ width: "100%", display: "flex", justifyContent: "space-between" }}
>
  <li style={{ visibility: data?.qrCodeUrl ? "visible" : "hidden", marginLeft:"20px" }}>
    {data?.qrCodeUrl && (
      <img src={data?.qrCodeUrl} style={{ width: "50px", height: "50px" }}  onClick={() => handleQrClick(data?.qrCodeUrl)}/>
    )}
  </li>
  
  {data?.selfCreated && (
    <li>
      <Link 
        onClick={() => handleShowEdit(data)} 
        className="material-symbols-outlined"
      >
        edit
      </Link>
    </li>
  )}
</ul>


                            </div>

                            {/* <div className="top-bg-image">
                  <img src={img1} className="img-fluid w-100" alt="group-bg" />
                </div> */}
                            <Card.Body className=" text-center">
                              <div className="group-icon">
                                <img
                                  src={
                                    data?.uploadedFileLink
                                      ? data?.uploadedFileLink
                                      : "/profile.png"
                                  }
                                  alt="profile-img"
                                  style={{ position: "relative" }}
                                  className="rounded-circle img-fluid avatar-120"
                                />
                              </div>
                              <div className="group-info pt-3 ">
                                <h4>
                                  <Link
                                    onClick={() => handleNavigate(data?._id)}
                                  >
                                    {data?.groupName}
                                  </Link>
                                  <div className="text-primary" style={{textTransform:"capitalize", fontSize:"12px"}}>({data?.category})</div>
                                </h4>
                                {/* <div
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: data?.description,
                                  }}
                                ></div> */}
                              </div>
                              {data?.note ? (
    <div
      style={{
        color: "red",
        fontSize: "14px",
        marginTop: "10px",
        textAlign: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
      }}
    >
      {t("note")}: {data?.note}
    </div>
  ) : (
    <div style={{ visibility: "hidden", height: "25px", marginTop: "10px" }}>
      {/* Hidden placeholder for alignment */}
    </div>
  )}

                              <div className="group-details d-inline-block pb-3">
                                <ul className="d-flex align-items-center justify-content-between list-inline m-0 p-0">
                                  <li className="pe-3 ps-3">
                                    <p className="mb-0">{t('post')}</p>
                                    <h6>{data?.postCount}</h6>
                                  </li>
                                  <li className="pe-3 ps-3">
                                    <p className="mb-0">{t('member')}</p>
                                    <h6>{data?.memberCount}</h6>
                                  </li>
                                </ul>
                              </div>

                              <button
                                type="submit"
                                className="btn btn-primary d-block w-100"
                                onClick={() => handleNavigate(data?._id)}
                                // onClick={() => handleJoinGroup(data?._id)}
                              >
                                {t('visit')}
                              </button>
                            </Card.Body>
                          </Card>
                        ))
                      ) : (
                        <p>{t('no_groups_available')}</p>
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="f2">
                  <Card
                      id="post-modal-data"
                      className="card-block card-stretch card-height"
                    >
                      <div className="card-header d-flex justify-content-between">
                        <div className="header-title">
                          <h4 className="card-title">{t('create_group')}</h4>
                        </div>
                      </div>
                      <Card.Body>
                        <div className="d-flex align-items-center">
                          <div className="user-img">
                            <img
                            src={profileImage}
                              //  src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`}
                              alt="user1"
                              className="avatar-60 rounded-circle"
                            />
                          </div>
                          {/* <div className="user-img">
                        <img
                          className="rounded-circle img-fluid"
                          src="/calender.webp"
                          style={{ width: "85px" }}
                          alt=""
                        />
                        <div
                          style={{
                            justifyContent: "center",
                            fontSize: "24px",
                            fontWeight: "600",
                            marginTop: "-65%",
                            display: "flex",
                            color: "rgb(58,51,61)",
                          }}
                        >
                          {currentDate}
                        </div> */}
                          {/* <i className="ri-calendar-line"></i> */}
                          {/* </div> */}
                          <form
                            className="post-text ms-3 w-100 "
                            onClick={handleShow}
                          >
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder={t('click_to_create_group')}
                              style={{ border: "none" }}
                            />
                          </form>
                        </div>
                      </Card.Body>
                      <Modal centered
                        size="lg"
                        className="fade"
                        id="post-modal"
                        onHide={handleClose}
                        show={show}
                        style={{ overflow: "hidden" }}
                      >
                        <Modal.Header className="d-flex justify-content-between">
                          <Modal.Title id="post-modalLabel">
                            {t('create_group')}
                          </Modal.Title>
                          <Link to="#" className="lh-1" onClick={handleClose}>
                            <span className="material-symbols-outlined">
                              close
                            </span>
                          </Link>
                        </Modal.Header>
                        <Modal.Body
                          style={{ maxHeight: "60lvh", overflowY: "auto" }}
                        >
                          <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t('group_name')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="groupname"
                                  value={formData.groupname}
                                  onChange={handleChange}
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('enter_group_name')}
                                  required
                                />
                              </Form.Group>
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                {t('description')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                {/* <CKEditor
                        editor={ClassicEditor}
                        data="<p>What's on your mind?</p>"
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setDescription(data);
                        }}
                      /> */}
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  name="description"
                                  value={description}
                                  onChange={(e) =>
                                    setDescription(e.target.value)
                                  }
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('description')}
                                  required
                                />
                              </Form.Group>
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t('select_a_category')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <div className="mb-0 ">
                                  <Form.Check
                                    style={{ marginRight: "20px", whiteSpace:"nowrap" }}
                                    type="radio"
                                    name="category"
                                    value="public"
                                    label={t('public')}
                                    checked={categorypost === "public"}
                                    onChange={handleCategoryChange}
                                    required
                                  />
                                  <Form.Check style={{whiteSpace:"nowrap"}}
                                    type="radio"
                                    name="category"
                                    value="private"
                                    label={t('private')}
                                    checked={categorypost === "private"}
                                    onChange={handleCategoryChange}
                                    required
                                  />
                                </div>
                              </Form.Group>
                            </li>

                            <li className="col-12 mb-3">
                              <Form.Label>
                              {t('image')} <span style={{ color: "red" }}>*</span>
                              </Form.Label>

                              <label
                                htmlFor="file-input"
                                style={{ cursor: "pointer", width: "100%" }}
                              >
                                <div
                                  className="bg-soft-primary rounded p-1 pointer"
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: "1.2rem",
                                    position: "relative",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <input
                                    id="file-input"
                                    type="file"
                                    name="file"
                                    style={{ display: "none" }}
                                    onChange={handleChangeImage}
                                  />
                                  <span>
                                    {formData.image ? (
                                      <MdOutlineDone
                                        style={{ fontSize: "25px" }}
                                      />
                                    ) : (
                                      <i className="fas fa-upload"></i>
                                    )}
                                  </span>
                                  <p style={{ marginTop: ".5rem" }}>
                                    {t('click_to_select_files')}
                                  </p>
                                </div>
                              </label>
                              {imagePreview && imagePreview.length > 0 && (
  <div className="mt-2">
    {imagePreview.map((preview, index) => (
      <img
        key={index}
        src={preview}
        alt={`Selected ${index}`}
        style={{ width: '70px', borderRadius: '10px', marginBottom: '10px' }}
      />
    ))}
  </div>
)}

                            </li>
                            <li className="col-12 mb-3">
                              <Form.Label>
                              {t('background_image')} <span style={{ color: "red" }}>*</span>
                              </Form.Label>

                              <label
                                htmlFor="file-inputCover"
                                style={{ cursor: "pointer", width: "100%" }}
                              >
                                <div
                                  className="bg-soft-primary rounded p-1 pointer"
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: "1.2rem",
                                    position: "relative",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <input
                                    id="file-inputCover"
                                    type="file"
                                    name="backgroundImg"
                                    style={{ display: "none" }}
                                    onChange={handleChangeImageBG}
                                  />
                                  <span>
                                    {formData.backgroundImg ? (
                                      <MdOutlineDone
                                        style={{ fontSize: "25px" }}
                                      />
                                    ) : (
                                      <i className="fas fa-upload"></i>
                                    )}
                                  </span>
                                  <p style={{ marginTop: ".5rem" }}>
                                    {t('click_to_select_files')}
                                  </p>
                                </div>
                              </label>
                              {imagePreviewBG && imagePreviewBG.length > 0 && (
  <div className="mt-2">
    {imagePreviewBG?.map((preview, index) => (
      <img
        key={index}
        src={preview}
        alt={`Selected ${index}`}
        style={{ width: '70px', borderRadius: '10px', marginBottom: '10px' }}
      />
    ))}
  </div>
)}

                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>{t('note')} </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="note"
                                  value={formData.note}
                                  onChange={handleChange}
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('note')}
                                  required
                                />
                              </Form.Group>
                            </li>
                          </ul>

                          <button
                            type="submit"
                            className="btn btn-primary d-block w-100 mt-3"
                            onClick={handleGroup}
                          >
                            {t('Create')}
                          </button>
                        </Modal.Body>
                      </Modal>
                      <Modal
                        size="lg"
                        className="fade"
                        id="post-modal"
                        onHide={handleCloseEdit}
                        show={showEdit}
                        style={{ marginTop: "100px", overflow: "hidden" }}
                      >
                        <Modal.Header className="d-flex justify-content-between">
                          <Modal.Title id="post-modalLabel">
                            {t('edit_group')}
                          </Modal.Title>
                          <Link to="#" className="lh-1" onClick={handleCloseEdit}>
                            <span className="material-symbols-outlined">
                              close
                            </span>
                          </Link>
                        </Modal.Header>
                        <Modal.Body
                          style={{ maxHeight: "60lvh", overflowY: "auto" }}
                        >
                          <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t('group_name')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="groupname"
                                  value={formDataEdit.groupname}
                                  onChange={handleChangeEdit}
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('enter_group_name')}
                                  required
                                />
                              </Form.Group>
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                {t('description')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                {/* <CKEditor
                        editor={ClassicEditor}
                        data="<p>What's on your mind?</p>"
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setDescription(data);
                        }}
                      /> */}
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  name="description"
                                  value={descriptionEdit}
                                  onChange={(e) =>
                                    setDescriptionEdit(e.target.value)
                                  }
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('description')}
                                  required
                                />
                              </Form.Group>
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t('select_a_category')}{" "}
                                  <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <div className="mb-0 ">
                                  <Form.Check
                                    style={{ marginRight: "20px" }}
                                    type="radio"
                                    name="category"
                                    value="public"
                                    label={t('public')}
                                    checked={categorypostEdit === "public"}
                                    onChange={handleCategoryChangeEdit}
                                    required
                                  />
                                  <Form.Check
                                    type="radio"
                                    name="category"
                                    value="private"
                                    label={t('private')}
                                    checked={categorypostEdit === "private"}
                                    onChange={handleCategoryChangeEdit}
                                    required
                                  />
                                </div>
                              </Form.Group>
                            </li>

                            <li className="col-12 mb-3">
                              <Form.Label>
                              {t('image')} <span style={{ color: "red" }}>*</span>
                              </Form.Label>

                              <label
                                htmlFor="file-input"
                                style={{ cursor: "pointer", width: "100%" }}
                              >
                                <div
                                  className="bg-soft-primary rounded p-1 pointer"
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: "1.2rem",
                                    position: "relative",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <input
                                    id="file-input"
                                    type="file"
                                    name="file"
                                    style={{ display: "none" }}
                                    onChange={handleChangeImageEdit}
                                  />
                                  <span>
                                    {formData.image ? (
                                      <MdOutlineDone
                                        style={{ fontSize: "25px" }}
                                      />
                                    ) : (
                                      <i className="fas fa-upload"></i>
                                    )}
                                  </span>
                                  <p style={{ marginTop: ".5rem" }}>
                                    {t('click_to_select_files')}
                                  </p>
                                </div>
                              </label>
                              {imagePreview && imagePreview.length > 0 && (
  <div className="mt-2">
    {imagePreview.map((preview, index) => (
      <img
        key={index}
        src={preview}
        alt={`Selected ${index}`}
        style={{ width: '70px', borderRadius: '10px', marginBottom: '10px' }}
      />
    ))}
  </div>
)}

                              {/* <div style={{display:"flex", width:"100%"}}>
                              <img src={formDataEdit?.image} alt="image" style={{display:"flex", width:"auto", height:"150px",  marginInline:"auto"}}/>

                              </div> */}

                              {/* <MuiFileInput  onChange={handleFileInputChange} /> */}
                            </li>
                            <li className="col-12 mb-3">
                              <Form.Label>
                              {t('background_image')} <span style={{ color: "red" }}>*</span>
                              </Form.Label>

                              <label
                                htmlFor="file-inputCoverEdit"
                                style={{ cursor: "pointer", width: "100%" }}
                              >
                                <div
                                  className="bg-soft-primary rounded p-1 pointer"
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: "1.2rem",
                                    position: "relative",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <input
                                    id="file-inputCoverEdit"
                                    type="file"
                                    name="backgroundImg"
                                    style={{ display: "none" }}
                                    onChange={handleChangeImageEditBG}
                                  />
                                  <span>
                                    {formData.backgroundImg ? (
                                      <MdOutlineDone
                                        style={{ fontSize: "25px" }}
                                      />
                                    ) : (
                                      <i className="fas fa-upload"></i>
                                    )}
                                  </span>
                                  <p style={{ marginTop: ".5rem" }}>
                                    {t('click_to_select_files')}
                                  </p>
                                </div>
                              </label>
                              {imagePreviewBG && imagePreviewBG.length > 0 && (
  <div className="mt-2">
    {imagePreviewBG?.map((preview, index) => (
      <img
        key={index}
        src={preview}
        alt={`Selected ${index}`}
        style={{ width: '70px', borderRadius: '10px', marginBottom: '10px' }}
      />
    ))}
  </div>
)}

                              {/* <div style={{display:"flex", width:"100%"}}>
                              <img src={formDataEdit?.image} alt="image" style={{display:"flex", width:"auto", height:"150px",  marginInline:"auto"}}/>

                              </div> */}

                              {/* <MuiFileInput  onChange={handleFileInputChange} /> */}
                            </li>
                            <li className="col-12 ">
                              <Form.Group className="form-group">
                                <Form.Label>{t('note')} </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="note"
                                  value={formDataEdit.note}
                                  onChange={handleChangeEdit}
                                  className="mb-0 py-2"
                                  id=""
                                  placeholder={t('note')}
                                  required
                                />
                              </Form.Group>
                            </li>
                          </ul>

                          <button
                            type="submit"
                            className="btn btn-primary d-block w-100 mt-3"
                            onClick={handleGroupEdit}
                          >
                            {t('update')}
                          </button>
                        </Modal.Body>
                      </Modal>

                      {/* Group Join PopUp */}
                      <Modal centered
                        size="md"
                        className=""
                        id="post-modal"
                        onHide={handleClose1}
                        show={show1}
                        style={{
                          // marginTop: "17%",
                          zIndex: "999999",
                          overflow: "hidden",
                        }}
                      >
                        <Modal.Header
                          className=""
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "none",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              flexDirection: "column",
                            }}
                          >
                            <Link
                              // to="#"
                              className="lh-1"
                              style={{
                                display: "flex",
                                justifyContent: "right",
                              }}
                              onClick={handleClose1}
                            >
                              <span className="material-symbols-outlined">
                                close
                              </span>
                            </Link>

                            <Modal.Title
                              id="post-modalLabel"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                fontSize: "24px",
                                paddingBlock: "30px",
                                textAlign: "center",
                              }}
                            >
                              {t('congratulations_in_group')}
                            </Modal.Title>
                          </div>
                          <button
                            type="submit"
                            style={{ display: "flex" }}
                            className="btn btn-primary d-block w-100 mt-3"
                            onClick={handleGroupDetail}
                          >
                            {t('visit_group')}
                          </button>
                        </Modal.Header>
                      </Modal>
                    </Card>
                    <div className="d-grid gap-3 d-grid-template-1fr-19">
                      {groups && groups.length > 0 ? (
                        groups.map((data) => (
                          <Card className="mb-0">
                            <div className="position-relative">
                              <img
                                loading="lazy"
                                src={data?.backgroundImageLink || img1}
                                alt="profile-bg"
                                style={{height:"120px", width:"100%"}}
                                className="rounded img-fluid"
                              />
<ul 
  className="header-nav list-inline d-flex align-items-center p-0 m-0" 
  style={{ width: "100%", display: "flex", justifyContent: "space-between" }}
>
  {data?.category === "public" && (
  <li style={{ visibility: data?.qrCodeUrl ? "visible" : "hidden", marginLeft:"20px" }}>
    {data?.qrCodeUrl && (
      <img src={data?.qrCodeUrl} style={{ width: "50px", height: "50px" }}  onClick={() => handleQrClick(data?.qrCodeUrl)}/>
    )}
  </li>)}
  
  {data?.selfCreated && (
    <li>
      <Link 
        onClick={() => handleShowEdit(data)} 
        className="material-symbols-outlined"
      >
        edit
      </Link>
    </li>
  )}
</ul>
                            </div>

                            {/* <div className="top-bg-image">
                  <img src={img1} className="img-fluid w-100" alt="group-bg" />
                </div> */}
                            <Card.Body className=" text-center">
                              <div className="group-icon">
                                <img
                                  src={
                                    data?.uploadedFileLink
                                      ? data?.uploadedFileLink
                                      : "/profile.png"
                                  }
                                  alt="profile-img"
                                  style={{ position: "relative" }}
                                  className="rounded-circle img-fluid avatar-120"
                                />
                              </div>
                              <div className="group-info pt-3 ">
                                <h4>
                                  <Link
                                    // onClick={() => handleNavigate(data?._id)}
                                  >
                                    {data?.groupName}
                                  </Link>
                                  <div className="text-primary" style={{textTransform:"capitalize", fontSize:"12px"}}>({data?.category})</div>

                                </h4>
                                {/* <div
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: data?.description,
                                  }}
                                ></div> */}
                              </div>
                              {data?.note ? (
    <div
      style={{
        color: "red",
        fontSize: "14px",
        marginTop: "10px",
        textAlign: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
      }}
    >
      {t("note")}: {data?.note}
    </div>
  ) : (
    <div style={{ visibility: "hidden", height: "25px", marginTop: "10px" }}>
      {/* Hidden placeholder for alignment */}
    </div>
  )}

                              <div className="group-details d-inline-block pb-3">
                                <ul className="d-flex align-items-center justify-content-between list-inline m-0 p-0">
                                  <li className="pe-3 ps-3">
                                    <p className="mb-0">{t('post')}</p>
                                    <h6>{data?.postCount}</h6>
                                  </li>
                                  <li className="pe-3 ps-3">
                                    <p className="mb-0">{t('member')}</p>
                                    <h6>{data?.memberCount}</h6>
                                  </li>
                                </ul>
                              </div>
                              {data?.category === 'private' ? (
  <button
    type="submit"
    className="btn btn-primary d-block w-100"
    onClick={() => handleJoinGroup(data?._id, true)}
  >
    {t('request')}
  </button>
) : (
  <button
    type="submit"
    className="btn btn-primary d-block w-100"
    onClick={() => handleJoinGroup(data?._id, false)}
  >
    {t('join')}
  </button>
)}

                            </Card.Body>
                          </Card>
                        ))
                      ) : (
                        <p>{t('no_groups_available')}</p>
                      )}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>

        <Container></Container>
      </div>
    </>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default Groups;
